import {
  ContentBorderWrapper,
  ContentContainer,
  ContentText,
  ContentTitle,
} from './styles';

export const ContentConnectYourWallet = () => {
  return (
    <ContentBorderWrapper>
      <ContentContainer>
        <ContentTitle>Connect</ContentTitle>
        <ContentText>Click on the Connect Wallet to get started.</ContentText>
      </ContentContainer>
    </ContentBorderWrapper>
  );
};
